import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { EaProfileFormBuilder } from './ea-profile-form.builder';

@Component({
    selector: 'ea-profile-form',
    templateUrl: './ea-profile-form.component.html',
    styleUrls: ['./ea-profile-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaProfileFormComponent),
        },
    ],
    standalone: false
})
export class EaProfileFormComponent
  extends EaProfileFormBuilder
  implements OnInit
{
  users: any[];
  frenchMobilePhoneRegex = /^0(6\d{8}|7\d{8}|69\d{7})$/;
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  legalCapacities: any[];
  countries: any[];
  departments: any[];
  showWarningMobilePhone = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private referenceDao: ReferenceDao,
    private translateService: TranslateService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.referenceDao.getLegalCapacity(),
      this.referenceDao.getCountries(),
      this.referenceDao.getDepartment(),
    ]).subscribe(([users, legalCapacities, countries, departments]) => {
      this.legalCapacities = legalCapacities;
      this.countries = countries;
      this.departments = departments;
    });

    this.showWarningMobilePhone = this.enableWarningMobilePhone(
      this.form.get('mobile').value,
    );

    this.form.get('mobile').valueChanges.subscribe(value => {
      this.showWarningMobilePhone = this.enableWarningMobilePhone(value);
    });
  }

  enableWarningMobilePhone(mobilePhone: string): boolean {
    const isValidAndFrenchMobilePhone =
      mobilePhone &&
      mobilePhone.length === 10 &&
      (mobilePhone.startsWith('06') || mobilePhone.startsWith('07'));

    if (!isValidAndFrenchMobilePhone) {
      return false;
    }

    return !this.frenchMobilePhoneRegex.test(mobilePhone);
  }

  onSubmit() {
    //Fetch every form controls value
    const extracted = this.extract();
    let formDTOExtraction = _.merge(this.entity, extracted);
    formDTOExtraction.otherFirstNames = extracted.otherFirstNames;
    this.prFormService.loading();
    this.userDao.updateUser(formDTOExtraction).subscribe(
      success => {
        this.prFormService.loaded();
        this.doneSubject.next();
        this.notificationService.success('La sauvegarde a réussi');
      },
      errors => {
        console.error(errors);
        this.prFormService.loaded();
        this.notificationService.error('La sauvegarde a échoué');
      },
    );
  }

  displayDepartment(option: any): string {
    return `${option.id} - ${option.value}`;
  }
}
